import { render, staticRenderFns } from "./RecentTxHeader.vue?vue&type=template&id=db8474e4&scoped=true&"
import script from "./RecentTxHeader.vue?vue&type=script&lang=ts&"
export * from "./RecentTxHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RecentTxHeader.vue?vue&type=style&index=0&id=db8474e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8474e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VTooltip})
